import type React from "react";

import { Hidden } from "shared/atoms/Hidden";
import { MUIUnifiedModal } from "shared/atoms/MUIUnifiedModal";
import { Tooltip } from "shared/molecules/Tooltip";

import { type QuickRepliesSize, getQuickRepliesConfig } from "../quickRepliesConfig";
import { QuickRepliesForm } from "../QuickRepliesForm";

interface Props {
  visible: boolean;
  onClose: () => void;
  onQuickReplySelected: (text: string) => void;
  size?: QuickRepliesSize;
}

export const QuickRepliesOverlay: React.FC<Props> = ({ visible, onClose, onQuickReplySelected, size = "default" }) => {
  const { offset, width } = getQuickRepliesConfig(size);

  return (
    <>
      <Hidden type="belowTablet">
        <Tooltip data-testid="quick-replies-overlay-desktop" requestClose={onClose} isOpen={visible} offset={offset}>
          <QuickRepliesForm width={width} onQuickReplySelected={onQuickReplySelected} />
        </Tooltip>
      </Hidden>
      <Hidden type="aboveTablet">
        <MUIUnifiedModal data-testid="quick-replies-overlay-mobile" open={visible} onClose={onClose}>
          <QuickRepliesForm onQuickReplySelected={onQuickReplySelected} />
        </MUIUnifiedModal>
      </Hidden>
    </>
  );
};
